module.exports = __webpack_public_path__ + "img/图片28.929dc186.png";